import { numericExtent, demaSeries } from "../utils";
const DEMA = {
    name: "DEMA",
    compute: (bars, period = 9) => demaSeries(bars.map((b) => b.close), period),
    computeExtents: (values) => numericExtent(values),
    render: () => undefined,
};
export default DEMA;
